import Joi from 'joi';
const offerBlockSchema = Joi.object({
  type: Joi.string().valid('offerBlock').required(),
  code: Joi.string().allow('', null).optional(),
  title: Joi.string().allow('', null).optional(),
  eyebrow: Joi.string().allow('', null).optional(),
  description: Joi.string().allow('', null).optional(),
  tiles: Joi.array().items(Joi.object({
    id: Joi.string().required(),
    label: Joi.string().allow('').required(),
    href: Joi.string().required(),
    target: Joi.string().allow('', null).optional(),
    image: Joi.string().allow('', null).optional()
  }).unknown(true)).required()
}).unknown(true);
export default offerBlockSchema;